import { appendResponseHeader } from 'h3';
import { parse, parseSetCookie, serialize } from 'cookie-es';

export default defineNuxtRouteMiddleware(async () => {
    const nuxtApp = useNuxtApp();
    // Don't run on client hydration when server rendered
    if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return;

    const {
      loggedIn,
      session,
      clear: clearSession,
      fetch: fetchSession
    } = useUserSession();

    if (!loggedIn.value) return;

    const accessToken = session.value.jwt?.accessToken;
    const refreshToken = session.value.jwt?.refreshToken;

    if (!accessToken || !refreshToken) return;

    const { tokenIsExpired } = useAuth();

    const serverEvent = useRequestEvent();
    const runtimeConfig = useRuntimeConfig();

    if (accessToken && refreshToken) {
      const accessTokenExpired = tokenIsExpired(accessToken);
      const refreshTokenExpired = tokenIsExpired(refreshToken);

      // If both tokens expired, clear the session and redirect to logout page
      if (accessTokenExpired && refreshTokenExpired) {
        await clearSession();
        return navigateTo('/logout');
      }
      // if only access token expired, refresh it
      else if (accessTokenExpired) {
        console.info('Access token expired, refreshing...');
        try {
          await useRequestFetch()('/api/jwt/refresh', {
            method: 'GET',
            onResponse({ response: { headers, status } }) {
              console.info('Access token refreshed successfully');
              // Forward the Set-Cookie header to the main server event
              if (import.meta.server && serverEvent) {
                for (const setCookie of headers.getSetCookie()) {
                  appendResponseHeader(serverEvent, 'Set-Cookie', setCookie);
                  // Update session cookie for next fetch requests
                  const { name, value } = parseSetCookie(setCookie);
                  if (name === runtimeConfig.session.name) {
                    // console.log('updating headers.cookie to', value)
                    const cookies = parse(serverEvent.headers.get('cookie') || '');
                    // set or overwrite existing cookie
                    cookies[name] = value;
                    // update cookie event header for future requests
                    serverEvent.headers.set('cookie', Object.entries(cookies).map(([name, value]) => {
                      return serialize(name, value);
                    }).join('; '));
                    // Also apply to serverEvent.node.req.headers
                    if (serverEvent.node?.req?.headers) {
                      serverEvent.node.req.headers['cookie'] = serverEvent.headers.get('cookie') || '';
                    }
                  }
                }
              }
            }
          });
        } catch (error) {
          console.error('Error refreshing access token:', error);
          await clearSession();
          return navigateTo('/logout');
        }
        // refresh the session
        await fetchSession();
      }

    } else {
      // // If no tokens are present, clear the session and redirect to logout page
      await clearSession();
      return navigateTo('/logout');
    }

  }
)
;





